
export default {
    state: {
        extensionEnable: false,
        extensionMenu: [],
    },
    getters: {
        getExtensionMenuSelected(state) {
            let selected
            state.extensionMenu.forEach(i => {
                if (!selected || selected.ratio < i.ratio) {
                    selected = i
                }
            })
            return selected.id
        },
        extensionMenu(state){
            return state.extensionMenu
        },
        extensionEnable(state){
            return state.extensionEnable
        }
    },
    actions: {

    },
    mutations: {
        setExtensionEnable(state, val) {
            state.extensionEnable = val
        },
        setExtensionMenu(state, val) {
            state.extensionMenu = val
        },
        setExtensionMenuRatio(state, {id, ratio}) {
            if (!state.extensionMenu) return
            let index = state.extensionMenu.findIndex(v => v.id === id)
            if (index >= 0 && state.extensionMenu[index]) {
                state.extensionMenu[index].ratio = ratio
            }
        }
    }
}
